import { createSlice } from '@reduxjs/toolkit'

const initialState = { username: '', name: '', email: '' }
export const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, { payload }) => {
      return payload
    },

    clearUser: (state, { payload }) => {
      return initialState
    },
  },
})

export const { updateUser, clearUser } = UserSlice.actions

export default UserSlice.reducer
